<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('SchiffPitchforkTool', function() {
            return {
                group: 'Lines', category: 'Pitchforks', icon: 'pitchfork.svg',
                type: 'SchiffPitchfork',
                name: 'Schiff Pitchfork',
                hint: "Schiff's Pitchfork",
                data: [],
                settings: {}
            }
        }, 'Schiff Pitchfork')
</script>
